var ShuttleListItem;

export default ShuttleListItem = Vue.extend({
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  template: `<div class="shuttle-list-item justify-between">
  <div class="justify-box details-box">
    <headimg :src='member.headimgurl'></headimg>
    <div class="darken-text ml-2 details-name">
      <div class="text-ellipsis">{{ member.name }}</div>
      <div class="text-small light-gray-text text-ellipsis">{{ member.identifier }}</div>
    </div>
  </div>
  <div class="darken-text ml-8">{{ member.phone }}</div>
  <span class="btn outlined btn-danger" @click="deleteSelectedMember(member)">移除</span>
</div>`,
  methods: {
    deleteSelectedMember: function(admin) {
      return this.$emit('deleteSelectedMember', admin);
    }
  }
});
